import {isExpectedError} from '@/src/shared/utils/expected-error'
import {toast} from 'react-toastify'
import * as Sentry from '@sentry/nextjs'

export const handleMutationException = (error: unknown) => {
  const _error: Error = error instanceof Error ? error : new Error(String(error).toString())

  if (isExpectedError(_error)) {
    // pass...
    return
  }

  toast.error(_error.message, {autoClose: 5000})
  Sentry.captureException(_error)
}
